import app from "@/data/app.json";
import navmenu from "@/data/navmenu.json";
import type { Lang } from "@/lib/types";
import { resolveBlogCategorySegments } from "./category-routes";

export const BLOG_LOCALES = app.activeLangs as Lang[];

export function isBlogLocale(value: string): value is Lang {
  return (BLOG_LOCALES as string[]).includes(value);
}

export function getBlogSegment(lang: Lang): string {
  const nav = navmenu.main.find((item) => item.en?.customPath === "blog");
  return nav?.[lang]?.url ?? "blog";
}

export function resolveLocalizedBlogRoute(locale: string, segments: string[] = []) {
  if (!isBlogLocale(locale)) return null;
  const [segment, slug, ...rest] = segments;
  if (![getBlogSegment(locale), "blog", "blogg"].includes(segment)) return null;
  const categorySlug = resolveBlogCategorySegments(segments.slice(1), locale);
  if (categorySlug) return { kind: "blog-category" as const, categorySlug, lang: locale };
  if (rest.length) return null;
  return slug ? { kind: "blog-post" as const, postSlug: slug, lang: locale } : { kind: "blog" as const, lang: locale };
}

export function blogLocaleFromPathname(pathname: string): Lang | null {
  const segments = pathname.split("/").filter(Boolean);
  if (segments[0] === "blog") return resolveLocalizedBlogRoute("en", segments)?.lang ?? null;
  return resolveLocalizedBlogRoute(segments[0], segments.slice(1))?.lang ?? null;
}
